const hero_slider = () => {
    var hero_swiper = new Swiper(".hero-swiper", {
        effect: "fade",
        speed: 500,
        autoplay: true,
        fadeEffect: { crossFade: true },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".prev-hero",
        },
        pagination: {
            el: ".swiper-pagination",
            type: "fraction",
        },
    });
}
export default hero_slider;